var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-form-item',{attrs:{"label":_vm.field.name}},[_c('a-input',{attrs:{"placeholder":"Vui lòng nhập dòng chữ","value":_vm.value},on:{"change":_vm.onChange}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }